module.exports = __webpack_public_path__ + "img/yx1.717d2f50.jpg";